var DigitLoginCasModule = /** @class */ (function () {
    function DigitLoginCasModule(initParams) {
        var _this = this;
        this.monitorUrl = ''; // 监听的地址
        this.container = '';
        this.mode = '';
        this.app = '';
        this.debug = true;
        this.monitorIframe = undefined;
        this.getLoginUid = undefined;
        this.onLoginChange = function (callback) {
            var cancel = false;
            var origin = new URL(_this.monitorUrl).origin;
            var wrappedCallback = _this.wrapSingleTabCallback(callback);
            var onMessage = function (e) {
                if (cancel) {
                    return;
                }
                if (_this.debug) {
                    console.log('onMessage', e);
                }
                if (e.origin !== origin) {
                    return;
                }
                var data = e.data;
                var type = data.type;
                var value = data.data;
                if (type === 'loginState') {
                    if (!_this.getLoginUid) {
                        if (_this.debug) {
                            console.log('没有配置getLoginUid,无法判断当前登录用户是否一致,跳过');
                        }
                        return;
                    }
                    // 初始登录状态
                    if (value.uid) {
                        var uid = _this.getLoginUid();
                        if (uid !== value.uid) {
                            if (_this.debug) {
                                console.log('登录用户不一致,重新发起单点登录');
                            }
                            wrappedCallback(value);
                        }
                    }
                    // else {
                    //     // 通知前端登出 这个不应被在这里实现 因为跨域问题也拿不到uid
                    //     // callback({ uid: 0 });
                    // }
                }
                else if (type === 'loginChange') {
                    if (_this.debug) {
                        console.log("\u901A\u884C\u8BC1\u767B\u5F55\u7528\u6237\u4E3A".concat(value.username, "(").concat(value.uid, ")"));
                    }
                    if (value.app && _this.app && value.app === _this.app) {
                        // 忽略当前APP自己触发的登录
                        if (_this.debug) {
                            console.log('当前应用触发的登录态变更,跳过');
                        }
                        return;
                    }
                    if (_this.debug) {
                        if (value.uid) {
                            console.log("\u5E94\u7528".concat(value.app, "\u89E6\u53D1\u4E86\u767B\u5F55\u6001\u53D8\u5316,\u65B0\u7684\u767B\u5F55\u7528\u6237\u4E3A").concat(value.username, "(").concat(value.uid, ")"));
                        }
                        else {
                            console.log('其他应用触发了登出');
                        }
                    }
                    wrappedCallback(value);
                }
                // 一定时间后自动移除登录iframe,这期间应该完成了自动单点
                // setTimeout(() => {
                //     try {
                //         if (debug) {
                //             console.log('已移除自动登录iframe');
                //         }
                //         removeMonitorIframe();
                //     } catch (e) {
                //         console.error(e);
                //     }
                // }, 5000);
            };
            window.addEventListener('message', onMessage, false);
            _this.injectMonitorIframe();
            return function () {
                cancel = true;
                window.removeEventListener('message', onMessage);
                _this.removeMonitorIframe();
            };
        };
        this.getSelector = function () { return document.querySelector(_this.container); };
        this.removeMonitorIframe = function () {
            if (_this.monitorIframe) {
                try {
                    var selector = _this.getSelector();
                    if (selector) {
                        selector.removeChild(_this.monitorIframe);
                    }
                }
                catch (e) {
                    if (_this.debug) {
                        console.log(e);
                    }
                }
                _this.monitorIframe = undefined;
            }
        };
        this.injectMonitorIframe = function () {
            var iframe = document.createElement('iframe');
            iframe.src = _this.monitorUrl;
            iframe.style.display = 'none';
            _this.monitorIframe = iframe;
            var selector = document.querySelector(_this.container);
            if (selector) {
                selector.appendChild(iframe);
            }
        };
        this.wrapSingleTabCallback = function (callback) { return function (value) {
            // 确保只有一个标签页处理了登录请求.
            // 如果打开多个标签页,每个标签页取一个随机数作为唯一ID,写入localStorage,最后取出最终的保留的ID作为唯一处理者
            var key = JSON.stringify(value) + Math.floor(Math.random() * 1000);
            window.localStorage.setItem('login_trigger_handler', key);
            setTimeout(function () {
                var handledKey = window.localStorage.getItem('login_trigger_handler');
                if (key === handledKey) {
                    callback(value);
                }
                else if (_this.debug) {
                    console.log('已在其他标签页响应本次登录态,跳过');
                }
            }, 250);
        }; };
        var _a = initParams.prodPassportUrl, prodPassportUrl = _a === void 0 ? 'https://fanruanclub.com/login/cas/monitor' : _a, _b = initParams.testPassportUrl, testPassportUrl = _b === void 0 ? 'https://passport.fanruan.com/login/cas/monitor' : _b, _c = initParams.mode, mode = _c === void 0 ? 'test' : _c, _d = initParams.container, container = _d === void 0 ? 'body' : _d, _e = initParams.app, app = _e === void 0 ? 'product' : _e, _f = initParams.debug, debug = _f === void 0 ? true : _f, monitorIframe = initParams.monitorIframe, getLoginUid = initParams.getLoginUid;
        this.mode = mode;
        this.monitorUrl = this.mode === 'test' ? testPassportUrl : prodPassportUrl;
        this.container = container;
        this.app = app;
        this.debug = debug;
        this.monitorIframe = monitorIframe;
        this.mode = mode;
        this.getLoginUid = getLoginUid;
    }
    return DigitLoginCasModule;
}());

export { DigitLoginCasModule as default };
